// extracted by mini-css-extract-plugin
export default {"icon":"my-store-map-marker__icon___1y26_"};